import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loadingFlag:0,
    data: [],
    masterData: {
        locationList: [],
        statusList: [],
        newStatusList: [],
        travelDistanceList: [],
        jobType: [],
        jobLevel:[],
        locationDistanceList:[]
    },
    params: {
        "page": 1,
        "pageSize": 25,
        "sortOrder": "",
        "sortColumn": "",
        "distance": "",
        "locationId": "",
        "employerUniqueId": "",
        "status": [],
        "SearchText": "",
        "isSearchWithCrieteria": false,
        "positions": [],
        "certifications": [],
        "specialities": [],
        "emrehrSystem": [],
        "shifts": [],
        "education": [],
        "covid19Vaccinated": [],
        "jobTypeid": 0,
        "JobTypeIdList":[],
        "PreferredShiftTimeOfTheDays": [],
        "includeDistance":false,
        "isExportExcel":false,
        "department":[]
    },
    error: false,
    errorMessage: null,
    totalCount: 0,
    dropDownJobId: 0,
    filterControls: [],
    isDataNotFound:false,
    sortOrderType:{id:null, type:null}
}

export const candidateSearchSlice = createSlice({
    name: 'candidateSearchInfoV2',
    initialState,
    reducers: {
        setCandidateSearchInfo: (state, action) => {
            state.data = action.payload;
        },
        setMasterData: (state, action) => {
            if (action.payload.location) {
                state.masterData.locationList = action.payload.location;
                state.masterData.statusList = action.payload.status;
                state.masterData.newStatusList = action.payload.newstatus;
                state.masterData.travelDistanceList = action.payload.travelDistance;
                state.masterData.jobType = action.payload.jobType;
                state.masterData.jobLevel = action.payload.jobLevel
            }
        },
        setError: (state, action) => {
            state.error = true;
            state.errorMessage = action.payload;
        },
        resetError: (state) => {
            state.error = false;
            state.errorMessage = null;
        },
        setParams: (state, action) => {
            state.params = action.payload;
        },
        resetParams: (state) => {
            state.params = {
                "page": 1,
                "pageSize": 100,
                "sortOrder": "",
                "sortColumn": "",
                "distance": "",
                "locationId": "",
                "employerUniqueId": "",
                "status": [],
                "SearchText": "",
                "isSearchWithCrieteria": false,
                "positions": [],
                "certifications": [],
                "specialities": [],
                "emrehrSystem": [],
                "shifts": [],
                "education": [],
                "covid19Vaccinated": [],
                "jobTypeid": 0,
                "JobTypeIdList":[],
                "preferredShiftTimeOfTheDaysList": [],
                "includeDistance":false,
                "department":[]

            };
        },
        setTotalCount: (state, action) => {
            state.totalCount = action.payload;
        },
        setDropdownJobId: (state, action) => {
            state.dropDownJobId = action.payload
        },
        setFilterControls: (state, action) => {
            state.filterControls = action.payload
        },
        setLoadingFlagIncrement:state => {
            state.loadingFlag = state.loadingFlag + 1
        },
        setLoadingFlagDecrement: state => {
            if (state.loadingFlag !== 0) {
                state.loadingFlag = state.loadingFlag - 1
            }
        },
        updateJobLevelList:(state,{payload}) => {
            state.masterData.jobLevel=payload;
        },
        updateIncludeDistance:(state,{payload}) => {
            state.params.includeDistance = payload
        },
        setIsDataNotFound:(state,{payload}) => {
            state.isDataNotFound = payload
        }, 
        setLocationDistanceList:(state,{payload}) => {
            state.masterData.locationDistanceList = payload;
        },
        setSortOrderType:(state,{payload}) => {
            state.sortOrderType = payload;
        }
    }
});

export const { setCandidateSearchInfo, setMasterData, setError, resetError, setParams, resetParams, setTotalCount, setDropdownJobId, setFilterControls,setLoadingFlagIncrement,setLoadingFlagDecrement,updateJobLevelList , updateIncludeDistance,setIsDataNotFound , setLocationDistanceList, setSortOrderType} = candidateSearchSlice.actions;

export default candidateSearchSlice.reducer;